import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: 'Platform',
    links: [
      { label: 'Features', to: '/features' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Login', to: '/login' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'Private Equity AI', to: '/solutions/private-equity-ai' },
      { label: 'AI Due Diligence', to: '/solutions/ai-due-diligence' },
      { label: 'CIM Analysis', to: '/solutions/cim-analysis-software' },
      { label: 'AI Financial Modeling', to: '/solutions/ai-financial-modeling' },
      { label: 'IC Memo Automation', to: '/solutions/ic-memo-automation' },
      { label: 'Portfolio Monitoring AI', to: '/solutions/portfolio-monitoring-ai' },
    ],
  },
  {
    title: 'Use Cases',
    links: [
      { label: 'Managing Partners', to: '/use-cases/managing-partners' },
      { label: 'Deal Teams', to: '/use-cases/deal-teams' },
      { label: 'Portfolio Operations', to: '/use-cases/portfolio-ops' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog', to: '/blog' },
      { label: 'PE AI Tools Comparison', to: '/compare/private-equity-ai-tools' },
      { label: 'AI Diligence FAQ', to: '/resources/ai-due-diligence-faq' },
      { label: 'PE AI Buyers Guide', to: '/resources/private-equity-ai-buyers-guide' },
      { label: 'PE AI Security', to: '/resources/security-for-private-equity-ai' },
      { label: 'Implementation Playbook', to: '/resources/private-equity-ai-implementation-playbook' },
      { label: 'PE AI Glossary', to: '/resources/private-equity-ai-glossary' },
      { label: 'Answer Engine Hub', to: '/answer-engine', reloadDocument: true },
      { label: 'About', to: '/about' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Trust Center', to: '/trust' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
    ],
  },
];

export function MarketingFooter() {
  return (
    <footer className="marketing-footer px-5 py-16 md:px-8 md:py-20">
      <div className="max-w-[82rem] mx-auto">
        <div className="grid grid-cols-2 gap-x-8 gap-y-12 md:grid-cols-3 lg:grid-cols-[minmax(12rem,1.5fr)_repeat(5,minmax(0,1fr))] mb-14">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <Link to="/" className="marketing-footer__wordmark flex items-center gap-2 mb-4" aria-label="ReturnCatalyst home">
              <span className="marketing-wordmark__mark" aria-hidden="true"><i /><i /></span>
              <span className="marketing-wordmark">ReturnCatalyst</span>
            </Link>
            <p className="marketing-footer__brand-copy text-sm leading-relaxed">
              AI-powered deal operations for private equity. CIM analysis, IC simulation, and portfolio monitoring.
            </p>
            <p className="marketing-footer__brand-copy text-xs mt-3">
              Built by{' '}
              <a href="https://otomat.ai" target="_blank" rel="noopener noreferrer" className="marketing-footer__link transition-colors">
                Otomat
              </a>
            </p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="marketing-footer__heading text-[10px] uppercase tracking-[0.16em] font-bold mb-4">
                {col.title}
              </h4>
              <div className="space-y-1.5">
                {col.links.map((link) => (
                  <Link
                    key={link.label}
                    to={link.to}
                    reloadDocument={link.reloadDocument}
                    className="marketing-footer__link block text-xs transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="marketing-footer__legal pt-6 border-t border-white/15 text-xs tracking-wide">
          &copy; {new Date().getFullYear()} ReturnCatalyst. An Otomat product.
        </div>
      </div>
    </footer>
  );
}
